import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Card } from '../../base/card/Card.js';
import { BillDue } from '../billDue/BillDue.js';
import { Button } from '../../base/button/Button.js';
import { formatCurrency } from '../utils/formatCurrency.js';
import styles from './ApexBill.module.scss.js';
import { Skeleton } from './skeleton/Skeleton.js';

var getBillDueDetails = function (bill) {
    var variant = bill.isAutoPay ? 'recursive' : 'single';
    if (bill.billStatus === 'HAS_BILL' && bill.invoiceDueAmount) {
        return (jsxs(Fragment, { children: [jsx(Card.Title, __assign({ className: styles.title }, { children: formatCurrency(bill.invoiceDueAmount) })), jsx(BillDue, { date: bill.invoiceDueDate, variant: variant, hasError: false })] }));
    }
    if (bill.pastDueAmount) {
        return (jsxs(Fragment, { children: [jsx(Card.Title, __assign({ className: styles.title }, { children: formatCurrency(bill.pastDueAmount) })), jsx(BillDue, { variant: variant, hasError: true })] }));
    }
};
var ApexBill = function (_a) {
    var bill = _a.bill, phoneNumber = _a.phoneNumber, className = _a.className, style = _a.style;
    var isAutoPay = bill.isAutoPay;
    var productName = getProductName(bill.vehicles);
    var paymentPlan = getPaymentPlan(bill.paymentPlanPeriod, isAutoPay);
    var billStatus = bill.billStatus;
    var showCallToPay = !!phoneNumber && ((isAutoPay && billStatus === 'FAILED') || !isAutoPay);
    if (billStatus === 'NO_BILL') {
        return null;
    }
    return (jsxs(Card, __assign({ as: "article", "aria-label": "bill", className: clsx(styles.card, className), style: style }, { children: [jsx("div", { children: "Enthusiast+ policy" }), getBillDueDetails(bill), jsx(Card.Separator, {}), jsx("div", { children: productName }), paymentPlan && (jsxs(Fragment, { children: [jsx(Card.Separator, {}), jsx("div", { children: paymentPlan })] })), jsx(Card.Footer, __assign({ as: "footer", className: styles.footer }, { children: showCallToPay && (jsxs("div", __assign({ className: styles.callToPayWrapper }, { children: [jsx(Button, __assign({ size: "s", as: "a", href: phoneNumber.href }, { children: "Call to pay" })), jsxs("p", { children: ["In order to pay your bill, call ", jsx("a", __assign({ href: phoneNumber.href }, { children: phoneNumber.formatted }))] })] }))) }))] })));
};
function getProductName(vehicles) {
    var vehicleCount = vehicles.length;
    if (vehicleCount === 0)
        return '';
    return "".concat(vehicles[0]).concat(vehicleCount > 1 ? " +".concat(vehicleCount - 1) : '');
}
function getPaymentPlan(period, isAutoPay) {
    if (isAutoPay) {
        switch (period) {
            case 'ANNUAL':
                return 'Annual Payment Plan';
            case 'SEMIANNUAL':
                return 'Semi-Annual Payment Plan';
            case 'QUARTERLY':
                return 'Quarterly Payment Plan';
            case 'MONTHLY':
                return 'Monthly Payment Plan';
            default:
                return 'Payment Plan';
        }
    }
    else {
        return 'Annual premium';
    }
}
ApexBill.Skeleton = Skeleton;

export { ApexBill };
